import React, { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { LocationSearch } from '~components/forms/location';
import * as REST from '~services/rest';
import { searchCriteria } from '~containers/workers/list/searchCriteria';

import LocationContext from './locationContext';
import { getWorkersCount } from '~containers/intake/client/utils';
import { DEFAULT_PRICE } from '~constants/index.js';

const LocationSearchBar = () => {
  const intl = useIntl();

  const history = useHistory();

  const { locationDetails, isLoadingLocation, onChangeLocation } = useContext(LocationContext);

  const [address, setAddress] = useState(locationDetails);

  useEffect(() => {
    if (!address) {
      setAddress(locationDetails);
    }
  }, [locationDetails]);

  // const handleAddressChange = (loc) => {
  //   if (!loc) {
  //     return;
  //   }

  //   const newLocation = {
  //     locationId: loc.place_id,
  //     address: loc.address,
  //   };

  //   setAddress(newLocation);

  //   history.push({
  //     pathname: `/workers`,
  //     search: `?locationId=${loc.place_id}`,
  //     state: {
  //       location: newLocation,
  //     },
  //   });

  //   onChangeLocation(loc.place_id);
  // };

  const handleAddressChange = async (loc) => {
    if (!loc) {
      return;
    }
  
    const newLocation = {
      locationId: loc.place_id,
      address: loc.address,
    };
  
    setAddress(newLocation);
  
    try {
      const locationResponse = await REST.get({
        name: 'locations',
        mockFileName: 'locations/get-by-id',
        params: { 'place-id': loc.place_id },
      });
  
      const first = locationResponse?.data?.[0];
      const locData = first?.location;
      const priceData = first?.pricing;
  
      const locationDetails = locData
        ? { ...locData, locationId: locData.place_id, address: locData.address }
        : null;
  
      const pricingDetails =
        priceData?.currency != null &&
        priceData?.min_price != null &&
        priceData?.max_price != null
          ? {
              currency: priceData.currency,
              minPrice: priceData.min_price,
              maxPrice: priceData.max_price,
            }
          : DEFAULT_PRICE;
  
      // If we cannot build a usable location, just go to list
      if (!locationDetails || locationDetails.latitude == null || locationDetails.longitude == null) {
        history.push({
          pathname: `/workers`,
          search: `?locationId=${loc.place_id}`,
          state: { location: newLocation },
        });
        onChangeLocation(loc.place_id);
        return;
      }
  
      // SAME logic as banner
      const resultsCount = await getWorkersCount(locationDetails, pricingDetails, {});
  
      if (!resultsCount) {
        history.replace(`/intake/client?locationId=${loc.place_id}`);
        return;
      }
    } catch (e) {
      // On error, fall through to list
    }
  
    history.push({
      pathname: `/workers`,
      search: `?locationId=${loc.place_id}`,
      state: { location: newLocation },
    });
    onChangeLocation(loc.place_id);
  };

  return (
    <div className="c-subheader">
      <div className="c-subheader__location-fieldset">
        <LocationSearch
          isDataLoading={isLoadingLocation}
          location={address}
          placeholder={intl.formatMessage({
            id: 'containers.workers.subheader.address',
            defaultMessage: 'Address',
          })}
          className="c-subheader__location-search c-autocomplete--focus-disabled"
          onSubmit={(loc) => handleAddressChange(loc)}
        />
      </div>
    </div>
  );
};

export default LocationSearchBar;
